import SERVER_URL from '../Global';
import { errorInterceptor } from '../util/axiosConfig';
const axios = require('axios').default;

export default class FileService {
    constructor(token) {
        this.api_token = token;
        this.client = null;
        this.api_url = SERVER_URL;
    }
    init = () => {
        let headers = {
            Accept: "application/json",
        };
        if (this.api_token) {
            headers.Authorization = `Bearer ${this.api_token}`;
        }
        this.client = axios.create({ baseURL: this.api_url, timeout: 0, headers: headers });
        this.client.interceptors.response.use(errorInterceptor);
        return this.client;
    };

    addFile = (data) => {
        return this.init().post('api/file/update', data)
    }

    downloadFile = (id) => {
        return this.init().get('api/file/download/' + id, { responseType: 'blob' })
    }

    deleteFile = (id) => {
        return this.init().delete('api/file/' + id)
    }
}


// WEBPACK FOOTER //
// ./src/Services/fileService.js